import React from 'react'
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm'

import styles from '../component-styles/audit-table-body.module.scss'
import Button from './button'
import Cross from '../svgs/cross'
import Tick from '../svgs/tick'
import { getToken } from '../helpers'
import { logAction } from '../api-client/analytics-client'
import ToggleBox from './toggle-box'
import { Tag } from './add-multi-values-tags'

interface Props {
  data: AuditTableEntry[]
  type: 'passed' | 'failed'
  toggleActive: (title: string) => void
}

export default function TableBody({
  data,
  type,
  toggleActive,
}: Props): React.ReactElement {
  return (
    <>
      {data.map(
        (entry: AuditTableEntry): React.ReactElement => {
          const {
            title,
            category,
            definitionMarkdown,
            resultMarkdown,
            solutionMarkdown,
            gaLink,
          } = entry
          const icon =
            type === 'passed' ? (
              <Tick
                className={styles.marker}
                style={{
                  fill: '#0FC3F0',
                }}
              />
            ) : (
              <Cross
                className={styles.marker}
                style={{
                  fill: '#E61969',
                }}
              />
            )

          return (
            <ToggleBox
              className={styles.toggleBoxWrapper}
              icon={icon}
              key={entry.title}
              heading={title}
              optional={
                <Tag className={styles.tag} type="grey" compact>
                  {category.toLowerCase()}
                </Tag>
              }
              onToggle={async (active) => {
                const s = !active
                if (s) {
                  // @ts-ignore
                  if (window.dataLayer && window.dataLayer.push) {
                    const token = getToken()
                    // @ts-ignore
                    window.dataLayer.push({
                      event: 'audit-expand-solution',
                      token,
                    })
                  }
                  const { testid, testPass } = entry
                  const actionData = {
                    action: testPass
                      ? 'open-passed-audit-solution'
                      : 'open-failed-audit-solution',
                    longDescription: testid,
                    websiteSection: 'audit',
                  }
                  await logAction(actionData)
                }
              }}
            >
              <>
                <h3 className={styles.titles}>Definition:</h3>
                <ReactMarkdown plugins={[gfm]}>
                  {definitionMarkdown}
                </ReactMarkdown>
                <h3 className={styles.titles}>Result:</h3>
                <ReactMarkdown plugins={[gfm]}>{resultMarkdown}</ReactMarkdown>
                <h3 className={styles.titles}>Solution:</h3>
                <ReactMarkdown plugins={[gfm]}>
                  {solutionMarkdown}
                </ReactMarkdown>
                <div className={styles.row}>
                  <Button onClick={(): void => toggleActive(title)}>
                    Request an expert
                  </Button>
                  <Button
                    type="hollowBorder"
                    href={
                      gaLink !== 'None'
                        ? gaLink
                        : 'https://analytics.google.com/'
                    }
                    newTab
                  >
                    Go to GA settings
                  </Button>
                </div>
              </>
            </ToggleBox>
          )
        },
      )}
    </>
  )
}
